import { useContext } from 'react'
import { UIVariantContext, type UIVariantContextValue } from './context'

export function useUIVariant(): UIVariantContextValue {
  return useContext(UIVariantContext)
}
